import { PublicClientApplication } from "@azure/msal-browser";
import { PATHS } from "../routes/paths";

// Caminho da rota de callback usada no retorno do login Azure AD
const CALLBACK_PATH = PATHS.AUTH_CALLBACK_AZURE_AD;

// URI de redirecionamento usada pelo MSAL após autenticação
const REDIRECT_URI =
  typeof window !== "undefined"
    ? `${window.location.origin}${CALLBACK_PATH}`
    : `http://localhost:3000${CALLBACK_PATH}`;

type GetMsalInstanceParams = {
  clientId: string;
  authority: string;
};

// Cria e retorna uma instância configurada do MSAL para autenticação Azure AD
export const getMsalInstance = ({
  clientId,
  authority,
}: GetMsalInstanceParams) => {
  if (!clientId) {
    throw new Error(
      "[msalConfig] clientId é obrigatório para criar a instância.",
    );
  }
  if (!authority) {
    throw new Error(
      "[msalConfig] authority é obrigatório para criar a instância.",
    );
  }

  return new PublicClientApplication({
    auth: {
      clientId,
      authority,
      redirectUri: REDIRECT_URI,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: () => {},
        piiLoggingEnabled: false,
      },
    },
  });
};

// Instância global do MSAL não utilizada neste arquivo
export const msalInstance = null;
